import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import PublicLayout from "@/pages/public/PublicLayout";
import { ArrowLeft, Calendar, Building2 } from "lucide-react";

const fmtDate = (d) => { try { return new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }); } catch { return ""; } };

export default function PostDetailPage() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api.get(`/posts/public/${id}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [id]);

  const images = post
    ? [...new Set(((post.media?.direct_upload_files) || []).filter((m) => m.media_type === "image").map((m) => m.url)
        .concat((post.media?.linked_media_urls) || []).concat(post.cover ? [post.cover] : []))]
    : [];

  return (
    <PublicLayout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="post-detail-page">
        <Link to="/posts" className="inline-flex items-center gap-1 text-sm font-bold border-b-2 border-black mb-6" data-testid="post-detail-back">
          <ArrowLeft size={15} /> Back to News &amp; Updates
        </Link>
        {notFound && <div className="nb-card p-10 text-center" data-testid="post-detail-notfound">This post is no longer available.</div>}
        {post && (
          <article className="space-y-4" data-testid="post-detail-article">
            {post.category && <span className="nb-badge pf-accent-bg text-[11px]">{(post.category || "").replace("_", " ")}</span>}
            <h1 className="display text-3xl sm:text-4xl font-black" data-testid="post-detail-title">{post.title}</h1>
            <div className="flex items-center gap-3 text-sm text-black/50 flex-wrap">
              <span className="inline-flex items-center gap-1"><Calendar size={14} /> {fmtDate(post.published_at)}</span>
              <span className="inline-flex items-center gap-1"><Building2 size={14} /> {post.entity_name}</span>
            </div>
            {images[0] && <img src={images[0]} alt="" className="w-full rounded-xl border-2 border-black" />}
            {post.excerpt && <p className="text-lg text-black/70">{post.excerpt}</p>}
            <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: post.content_html || "" }} />
            {images.length > 1 && (
              <div className="grid grid-cols-2 gap-3">
                {images.slice(1).map((u, i) => <img key={i} src={u} alt="" className="rounded-lg border-2 border-black" />)}
              </div>
            )}
            {(post.tags || []).length > 0 && (
              <div className="flex flex-wrap gap-1 pt-2">{post.tags.map((tg) => <span key={tg} className="text-[11px] px-2 py-0.5 bg-black/5 rounded-full">#{tg}</span>)}</div>
            )}
          </article>
        )}
      </div>
    </PublicLayout>
  );
}
